import PropTypes from 'prop-types'
import React, { createRef } from 'react'
import Logo from '../Logo/Logo'
import Description from '../FocusableDiv/FocusableDiv'
import focusable from '../Focusable/Focusable'
import { truncate, addMore } from '../../../../shared/helpers'
import FadedImage from '../FadedImage/FadedImage'
import ActionButtons, { MY_LIST_BUTTON_TYPE } from './ActionButtons.jsx'
import ProgressBar from '../ProgressBar'
import ScrollingTextModal from '../ScrollingTextModal/ScrollingTextModal'
import { connect } from 'react-redux'
import * as UI from '../../lib/ui'
import tts from '../../lib/TTS.js'

const DESCRIPTION_TEXT = 'descriptionText'

class ContinueWatching extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: 'ContinueWatching',
      descriptionModalVisible: false,
    }
    this.actionButtonsRef = createRef()
    this.descriptionModal = createRef()
  }

  componentDidMount() {
    UI.registerFocusableComponent({ screen: this.state.id })
    UI.setLoadingState(false)

    const { pageDetails, continueWatchingData } = this.props.showDetail
    const { title } = pageDetails

    const { contentSeason, contentEpisode, contentTitle, contentDescription } =
      continueWatchingData

    tts.pushTextToRead(`...${title}`)
    tts.enqueueTextToRead(
      `...... Season ${contentSeason} Episode ${contentEpisode}: ${contentTitle} .... ${contentDescription}`
    )
  }

  onKeyEvent(key) {
    let handled = false
    const componentType = window.focusedComponent?.componentType
    if (key === 'UP' && componentType === MY_LIST_BUTTON_TYPE) {
      tts.addTextToRead(
        truncate.apply(this.props.showDetail.pageDetails.description_long, [
          100,
          true,
        ])
      )

      this.descriptionText?.setFocus()
      handled = true
    }

    if (key === 'DOWN' && componentType === DESCRIPTION_TEXT) {
      const actionButtonRef = this.actionButtonsRef.current
      actionButtonRef.instance.myListRef.current.setFocus()
      handled = true
    }

    if (key === 'ENTER' && componentType === DESCRIPTION_TEXT) {
      tts.stopRead()
      this.setState({ descriptionModalVisible: true })
      handled = true
    }

    if (key === 'BACK' && componentType === 'descriptionModal') {
      tts.stopRead()
      tts.addTextToRead(
        truncate.apply(this.props.showDetail.pageDetails.description_long, [
          100,
          true,
        ])
      )

      this.descriptionText?.setFocus()
      this.setState({ descriptionModalVisible: false })
      handled = true
    }
    return handled
  }

  onFocus() {
    this.actionButtonsRef.current.setFocus()
  }

  setActionButtonsRef = (component) => {
    if (component) {
      this.actionButtonsRef.current = component
      this.actionButtonsRef.current.setFocus()
    }
  }

  setDescriptionTextRef = (component) => {
    if (component) {
      this.descriptionText = component
    }
  }

  setDescriptionModalRef = (component) => {
    if (component) {
      this.descriptionModal = component
      this.descriptionModal?.setFocus()
    }
  }

  render() {
    const { pageDetails, continueWatchingData } = this.props.showDetail
    const { isFavorited } = this.props

    const {
      logo,
      title,
      mezzanineImage,
      description_long: showDescription,
    } = pageDetails
    const {
      contentHasSecondsWatched,
      contentSecondsWatched,
      contentDuration,
      contentSeason,
      contentEpisode,
      contentTitle,
      contentDescription,
    } = continueWatchingData

    const { descriptionModalVisible } = this.state

    const season = contentSeason ? `S${contentSeason}` : ''
    const episode = contentEpisode ? `E${contentEpisode}: ` : ''

    return (
      <>
        {descriptionModalVisible && (
          <ScrollingTextModal
            parent={this}
            center={true}
            visible={descriptionModalVisible}
            title={title}
            content={showDescription}
            componentType="descriptionModal"
            ref={this.setDescriptionModalRef}
          />
        )}
        <div className="continue-watching">
          <div className="continue-watching__information">
            <Logo
              className="continue-watching__information"
              hasLogo={!!logo}
              logoToDisplay={logo || title}
            />
            <Description
              className="continue-watching__information-description"
              parent={this}
              componentType="descriptionText"
              ref={this.setDescriptionTextRef}
            >
              <span className="continue-watching__information-description-text">
                {truncate.apply(showDescription, [100, true])}
              </span>
              <span className="continue-watching__information-description-more-text">
                {addMore.apply(showDescription, [100])}
              </span>
            </Description>
            <div className="continue-watching__information-buttons">
              <ActionButtons
                isFavorited={isFavorited}
                ref={this.setActionButtonsRef}
                parent={this}
                toggleError={this.props.toggleError}
              />
            </div>
          </div>
          <div className="continue-watching__content">
            <FadedImage
              className="continue-watching__content"
              imageSource={mezzanineImage}
            />
            <div className="continue-watching__content-video">
              <div className="continue-watching__content-video-details">
                <span className="continue-watching__content-video-details-title">{`${season} ${episode} ${contentTitle}`}</span>
                <span className="continue-watching__content-video-details-short-description">
                  {contentDescription}
                </span>
              </div>
              {contentHasSecondsWatched && (
                <div className="continue-watching__content-video-progress-bar">
                  <ProgressBar
                    current={contentSecondsWatched}
                    total={contentDuration}
                    fullWidth={true}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    )
  }
}

ContinueWatching.propTypes = {
  isFavorited: PropTypes.bool,
  toggleError: PropTypes.func,
  showDetail: PropTypes.shape({
    pageDetails: PropTypes.shape({
      title: PropTypes.string,
      logo: PropTypes.string,
      mezzanineImage: PropTypes.string,
      cid: PropTypes.string,
      description_long: PropTypes.string,
    }),
    continueWatchingData: PropTypes.shape({
      contentHasSecondsWatched: PropTypes.bool,
      contentSecondsWatched: PropTypes.number,
      contentDuration: PropTypes.number,
      contentSeason: PropTypes.number,
      contentEpisode: PropTypes.number,
      contentTitle: PropTypes.string,
      contentDescription: PropTypes.string,
    }),
  }),
}

const mapStateToProps = (state) => {
  return {
    showDetail: state.showDetail,
  }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  focusable(ContinueWatching)
)
